import {apiGet} from "@/services/apiService";

export async function getGallery(galleryUuid, authToken) {
    if (!galleryUuid || !authToken) return false;

    const galleryResponse = await apiGet(`/public/gallery/${galleryUuid}`, authToken);

    if (galleryResponse.ok) {
        const gallery = await galleryResponse.json();

        if (gallery?.error) {
            throw new Error(gallery.error);
        }

        if (gallery) {
            return gallery;
        }
    }

    return false;
}